import { Fragment } from "react";
import dynamic from "next/dynamic";
import parse from "html-react-parser";

import { dehydrate, QueryClient, useQuery } from '@tanstack/react-query';
import { getQueryFn, queryKeyManager } from "../../utils/api/queryFunction";
import queryConfig from "../../utils/api/queryConfig";

const SEO = dynamic(() => import("../../components/Shared/SEO"));
//Get page builder
const ProductLayout = dynamic(() => import("../../components/Layout/ProductLayout"));
const LazyLoad = dynamic(() => import("../../components/Shared/Image/LazyLoad"));
const SmallBanner = dynamic(() => import("../../components/Shared/Banners/SmallBanner"));

const FinancingPage = props => {
	const { token } = props;
	const { isLoading, isError, data } = useQuery({
		queryKey: queryKeyManager(['financing'], [token]),
		queryFn: () => getQueryFn('financing', token),
		...queryConfig
	})

	if (isLoading) {
		return <span />
	}

	return (
		<Fragment>
			<SEO seo={data.seo} />
			<ProductLayout nav={data.nav.header.links} logo={data.nav.header.logos.general} footer={data.nav.footer}>
				<SmallBanner banner={data.banner} />
				<div className="customContainer">
					<div className="row">
						<div className="col s12 mt64px">
							<h2>{data.introTitle}</h2>
						</div>
						<div className="col s12">
							{parse(data.introDescription)}
						</div>
					</div>
					<div className="row financingCardsHolder">
						{data.cards.map((card, i) => {
							return (
								<div className="col s12 m6 l4 financingCard" key={`financingCard-${i}`}>
									<div className="image">
										<LazyLoad image={card.image} />
										<div className="overlayTitle">
											{card.title}
										</div>
									</div>
									<div className="content">
										<h4 className="title">
											{card.cardTitle}
										</h4>
										<div className="description">
											{parse(card.cardDescription ? card.cardDescription : '')}
										</div>
										<div className="readMore">
											<a href={card.link.url} target={card.link.target} title={card.link.text}>{card.link.text}</a>
										</div>
									</div>
								</div>
							);
						})}
					</div>
				</div>
			</ProductLayout>
		</Fragment>
	);
};

FinancingPage.getInitialProps = async ({ query, req }) => {
	const queryClient = new QueryClient();
	const { token } = query;
	await queryClient.prefetchQuery({
		queryKey: queryKeyManager(['financing'], [token]),
		queryFn: () => getQueryFn('financing', token),
		...queryConfig
	});
	return {
		token: token,
		dehydratedState: dehydrate(queryClient)
	};
};

export default FinancingPage;